export default "__VITE_ASSET__DUXUz9Is__"